"use strict";

import Dexie from "dexie";

export class DB extends Dexie {
  login: Dexie.Table<LoginRow, number>;
  utenteslist: Dexie.Table<UtentesListRow, number>;

  constructor(cb: Function | null) {
    super("CVP");
    // let db = this;

    this.version(1).stores({
      login: "++id, user, password",
      utenteslist: "++id, nome, codigo, diagnostico, telefone, ultima_consulta",
    });

    this.login = this.table("login");
    this.utenteslist = this.table("utenteslist");

    this.open();
    this.on("ready", function() {
      if (cb) {
        cb();
      }
    });
  }

  isOpen(): boolean {
    return this.isOpen();
  }

  close(): void {
    this.close();
  }
}

export function initDB(db: DB | null): DB {
  if (!db) {
    db = new DB(null);
  }
  return db;
}

interface LoginRow {
  id?: number;
  user: string;
  password: string;
}
export interface UtentesListRow {
  id?: number;
  nome: string;
  codigo: string;
  diagnostico: string;
  telefone: string;
  ultima_consulta: string;
}
